import { useTranslation } from 'react-i18next'
import { useTimerStore } from '../../stores/timer-store'

const KIND_LABEL_KEY: Record<string, string> = {
  normal: 'workoutTimer.kind.normal',
  warmup: 'workoutTimer.kind.warmup',
  dropset: 'workoutTimer.kind.dropset',
  failure: 'workoutTimer.kind.failure',
}

export function ArmedPreview() {
  const { t } = useTranslation()
  const templates = useTimerStore((s) => s.templates)
  const exercise = useTimerStore((s) => s.exercise)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1 text-center">
        <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
          {exercise?.category?.name}
        </span>
        <h2 className="text-base font-semibold">{exercise?.title ?? ''}</h2>
        <p className="text-xs text-muted-foreground">
          {t('workoutTimer.armed.hint', 'Tap Start to begin. You will get a 5s preparation countdown.')}
        </p>
      </div>
      <ul className="flex flex-col gap-1.5 max-h-72 overflow-y-auto">
        {templates.map((tpl) => (
          <li key={tpl.id} className="flex items-center gap-2 rounded-md border p-2 bg-card">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
                  {t(KIND_LABEL_KEY[tpl.kind] ?? KIND_LABEL_KEY.normal)}
                </span>
                <p className="text-sm font-medium truncate">{tpl.title ?? '—'}</p>
              </div>
              <p className="text-xs text-muted-foreground">
                {t('workoutTimer.workoutDetail.summary', '{{sets}} sets × {{reps}} reps', {
                  sets: tpl.sets,
                  reps: tpl.reps_per_set,
                })}
                {tpl.work_seconds != null && ` · ${tpl.work_seconds}s`}
                {tpl.reps_target != null && ` · ${tpl.reps_target} reps`}
                {tpl.weight_percent != null && ` · ${tpl.weight_percent}%`}
                {tpl.rpe != null && ` · RPE ${tpl.rpe}`}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
